import type { ReactNode } from "react";

interface Props {
  watermark: string;
  sticker: ReactNode;
  heading: string;
  description: string;
  cta?: ReactNode;
}

export function ErrorPageShell({ watermark, sticker, heading, description, cta }: Props) {
  return (
    <section
      aria-labelledby="error-page-heading"
      className="relative flex min-h-screen items-center justify-center overflow-hidden px-6 py-16 md:min-h-[calc(100vh-200px)]"
    >
      <span
        aria-hidden
        className="pointer-events-none absolute select-none text-[10rem] font-black leading-none text-foreground/4 sm:text-[20rem] lg:text-[26rem]"
      >
        {watermark}
      </span>

      <div className="relative flex w-full max-w-xl flex-col items-center gap-8 text-center">
        <div className="motion-safe:animate-float">
          <div className="motion-safe:animate-peel-on">
            <div className="sticker-pen">
              <div className="sticker-container">
                <div className="sticker-wrapper">
                  <div className="sticker-clip">
                    <div className="sticker-front">{sticker}</div>
                    <div aria-hidden className="sticker-back" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-6 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-500 ease-out fill-mode-both">
          <div className="flex flex-col gap-3">
            <h1 id="error-page-heading" className="text-3xl font-bold sm:text-4xl">
              {heading}
            </h1>
            <p className="text-base text-muted-foreground sm:text-lg">{description}</p>
          </div>
          {cta}
        </div>
      </div>
    </section>
  );
}
